import { useState, useEffect } from "react"
import { ScrollContainer } from "react-indiana-drag-scroll"
import Button from "react-bootstrap/Button"
import { useFormik } from "formik"
import { useNavigate } from "react-router"
import * as Yup from "yup"
import api from "../../services/api"
import { formatDateWithTime } from "../../utils/dateFormat"
import NoDataFound from "../../shared/NoDataFound"
import Paginator from "../../shared/Paginator"
import { Toast } from "../../shared/Toast"
import config from "../../config"
import { useSelector } from "react-redux"
import TableLoader from "../../shared/TableLoader"
import { debounce } from "../../utils/Debounce"
import { SlTooltip, SlIconButton, SlDrawer, SlInput, SlButton, SlIcon } from "@shoelace-style/shoelace/dist/react"
import Select from "react-select"
import { BrandsTypes, teams } from "../../utils/constants"
import CryptoJS from "crypto-js"
import { roles, orderTablePermissions } from "../../utils/constants"
import PendingRequestModal from "../MakerChecker/components/PendingRequestModal"

const tempBrandsTypes = [{label: "All User Types", value: 0}, {label: "Main User", value: -1},...BrandsTypes, {label: "Network", value: 6}]
const assignedStatusOptions = [{label: "By Assigned", value :0}, {label: "Assigned to", value: 1}, {label: "UnAssigned to", value: 2}]

const initialSalesperson = {
  name: "",
  email: "",
  mobile: "",
  password: "",
  type: 0,
  region: -1,
  location: -1,
  team: "",
  permissions: [],
  assigned_sales_persons: [],
  whatsapp_reports: false,
  alpha_head: false,
  is_vendor_admin: false,
  designation: 0,
  new_user_type: 0,
  subordinates: [],
  ishead: false,
  newspaper_category_id: null,
  newspaper_category_name: null,
}
let initialValues = JSON.parse(JSON.stringify(initialSalesperson))

const SalespersonSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email().required("Email is required"),
  mobile: Yup.string()
    .matches(/^[6-9]\d{9}$/, "Invalid Mobile number")
    .min(10, "Mobile must be 10 digits")
    .max(10, "Mobile must be 10 digits")
    .required("Mobile Number is required"),
  password: Yup.string()
    .matches(/^[a-zA-Z0-9.\/!@#$%^&*+~?-]+$/, "Password should not contain any white space")
    .required("Password is required"),
  type: Yup.number().required("Sales Person type is required"),
  region: Yup.number().optional(),
  location: Yup.number().optional(),
  team: Yup.string().required("Team is required"),
  designation: Yup.number("Designation is Required")
    .min(1, "Designation is Required")
    .required("Designation is Required"),
  assigned_sales_persons: Yup.array(),
  subordinates: Yup.array(),
  new_user_type: Yup.number("Required").required("Required").notOneOf([0], "Required"),
  ishead: Yup.boolean(),
  newspaper_category_id: Yup.string().when('team', {
    is: (team) => team?.toLowerCase() === 'metro',
    then: Yup.string().required("Newspaper category is required for Metro team"),
    otherwise: Yup.string().nullable()
  })
  // region:Yup.number().required('Region is required'),
  // location:Yup.number().when('type', {
  //   is: 2,
  //   then: Yup.number().required('Location is required'),
  //   otherwise: Yup.number().optional()
  // })
})

// Edit never changes the password — no field, no validation. Reset it via forgot password.
const SalespersonEditSchema = SalespersonSchema.omit(['password'])

function Sales() {
  const navigate = useNavigate()
  const [submit, setSubmit] = useState(false)
  const [delId, setDelId] = useState(-1)
  const [delname, setDelname] = useState("")
  const [del, setDel] = useState(false)
  const [data, setData] = useState([])
  const [show, setShow] = useState(false)
  const [loader, setLoader] = useState(false)
  const [totalPages, setTotalPages] = useState(0)
  const [currentPage, setCurrentPage] = useState(0)
  const [salesp, setSalesp] = useState("")

  const [flag, setFlag] = useState("")
  const [locations, setLocations] = useState([])
  const [regions, setRegions] = useState([])
  const [id, setId] = useState("")
  const [search, setSearch] = useState("")
  const [depts, setDepts] = useState([])
  const [open, setOpen] = useState(false)
  const [region, setRegion] = useState("")
  const [location, setLocation] = useState("")
  const [view, setView] = useState(false)
  const [locationview, setLocationView] = useState(false)
  const [regionChange, setRegionChange] = useState("")
  const HeaderSearch = useSelector((state) => state.Head.adssearch)
  const [type, setType] = useState("0")
  const SALES = useSelector((state) => state.Head.opssales)
  const REGIONLOCATION = useSelector((state) => state.Head.regionlocation)
  const [initialRender, setInitialRender] = useState(true)
  const [targetView, setTargetView] = useState({ show: false })
  const [targetAssign, settargetAssign] = useState({})
  const [editTarget_ind, seteditTarget_ind] = useState(-1)
  const [editTarget, seteditTarget] = useState(-1)
  const [logshow, setlogshow] = useState({})
  const [logdata, setLogdata] = useState([])
  const [otp, setOtp] = useState({})
  const [selectedPermissions, setSelectedPermissions] = useState([])
  const [selectedSalesPersons, setSelectedSalesPersons] = useState([])
  const [assignedSalesPersons, setAssignedSalesPersons] = useState([])
  const [subordinatesList, setSubordinatesList] = useState([])
  const [designations, setDesignations] = useState([])
  const [designationString, setDesignationString] = useState("")
  const [designationView, setDesignationView] = useState(false)
  const [newspaperCategories, setNewsPaperCategories] = useState([])
  const [showNewspaperCategory, setShowNewspaperCategory] = useState(false)
  const [new_user_type_filter, setNew_user_type_filter] = useState(0)
  const [assigned_status_filter, setAssigned_status_filter] = useState(0)

  const [selectedMcId,setSelectedMcId] = useState('');
  const handleCloseModal = () => {
      setSelectedMcId(null);
  };
  let salesUserType = "",
    fixingType = ""
  if (localStorage.getItem("role") === roles.salesperson && localStorage.getItem("salesTabFlag")) {
    const decryptedSalesTabPermissions = CryptoJS.AES.decrypt(
      localStorage.getItem("salesTabFlag"),
      config.B2B_SECRET_KEY,
    )
    salesUserType = decryptedSalesTabPermissions.toString(CryptoJS.enc.Utf8)
  }

  const handle = () => {
    setOpen(false)
    setView(false)
    setLocationView(false)
    setId(null)
  }

  const viewDept = async (department_id) => {
    if (department_id?.length > 0) {
      try {
        const res = await api({
          url: `/user/sales_persons/viewDepartments`,
          method: "POST",
          responseType: "json",
          data: { department_id },
        })
        setDepts(res?.data)
      } catch (error) {
        Toast("error", "Something went wrong")
        if (error.response.status === 401) navigate("/")
      }
    } else {
      ; <span>NoDataFound</span>
      setDepts([])
    }
  }
  function handleDept() {
    setOpen(true)
  }

  const handleTypeChange = async (e) => {
    setType(e.target.value)
  }

  const handlePageClick = (event) => {
    setCurrentPage(event.selected)
    loadData(search, event.selected)
    setOtp({})
  }

  const handleClose = () => {
    setShow(false)
    setSubmit(false)
    setRegionChange("")
    setType("0")
    initialValues = JSON.parse(JSON.stringify(initialSalesperson))
    formik.setValues(initialValues)
    setSelectedPermissions([])
    setSelectedSalesPersons([])
    setId(null)
    setAssignedSalesPersons([])
    setShowNewspaperCategory(false)
    formik.resetForm()
  }

  useEffect(() => {
    Header()
  }, [HeaderSearch])

  const handleShow = async (choose, item) => {
    if (choose === "add") {
      formik.setValues(item)
      setShow(true)
    }
    if (choose === "edit") {
      setShow(true)
      setType(String(item.type))
      getRegions(String(item.type))
      setRegionChange(item.region !== -1 ? item.region : "")
      getLocations(item.region, String(item.type))

      initialValues.name = item.name
      initialValues.email = item.email
      initialValues.mobile = item.mobile
      // password is intentionally never loaded into the edit form — use forgot password to reset it
      initialValues.type = item.type
      initialValues.region = item.region ? item.region : -1
      initialValues.location = item.location ? item.location : -1
      initialValues.team = item.team ? item.team : ""
      initialValues.whatsapp_reports = item.whatsapp_reports == 1
      initialValues.alpha_head = item.alpha_head == 1
      initialValues.is_vendor_admin = item.is_vendor_admin == 1
      initialValues.designation = item.designation ? item.designation : 0
      initialValues.new_user_type = item.new_user_type || 0
      initialValues.subordinates = item.subordinates || []
      initialValues.ishead = item.ishead || false

      let permissionsArray = []
      if (item.permissions && item.permissions !== "") {
        const permissionsString = item.permissions.replace(/[{}"]/g, "")
        permissionsArray = permissionsString.split(",").map((permission) => permission.trim())
      }
      initialValues.permissions = permissionsArray
      initialValues.status = item.status
      formik.setValues(initialValues)
      formik.setFieldValue("whatsapp_reports", item.whatsapp_reports == 1)
      formik.setFieldValue("alpha_head", item.alpha_head == 1)
      formik.setFieldValue("is_vendor_admin", item.is_vendor_admin == 1)
      formik.setFieldValue("ishead", item.ishead)
      setSelectedPermissions(options.filter((option) => permissionsArray.includes(option.value)))
      let assignedSalesPersons = []
      if (item.assigned_sales) {
        assignedSalesPersons = JSON.parse(item.assigned_sales)
      }
      initialValues.assigned_sales_persons = assignedSalesPersons.map((item) => item.value)
      setSelectedSalesPersons(initialValues.assigned_sales_persons)
      await getAssignedSalesPersons(initialValues.type, initialValues.region)
      await getSubordinates(initialValues.new_user_type, item.sales_person_id)

      // Handle newspaper category for metro team
      if (item.team?.toLowerCase() === "metro") {
        await getNewsPaperCategories()

        setShowNewspaperCategory(true)
        if (item.newspaper_category_id) {
          initialValues.newspaper_category_id = item.newspaper_category_id
          initialValues.newspaper_category_name = item.newspaper_category_name
          formik.setFieldValue("newspaper_category_id", item.newspaper_category_id)
          formik.setFieldValue("newspaper_category_name", item.newspaper_category_name)
        }
      } else {
        setShowNewspaperCategory(false)
      }
    }
    getDesignations()
  }

  const deleteSales = async (id1) => {
    try {
      await api({
        url: `/user/sales_persons/${id1}`,
        method: "DELETE",
        responseType: "json",
      })
      Toast("success", "Sales Person Deleted Successfully")
      setCurrentPage(0)
      setSearch("")
      loadData(search, 0)
      setOtp({})
    } catch (error) {
      Toast("error", "Something went wrong")
      if (error.response.status === 401) navigate("/")
    }
  }

  const Header = () => {
    setSearch(HeaderSearch)
    setCurrentPage(0)
    if (!initialRender) loadData(HeaderSearch, 0)
  }

  const getNewsPaperCategories = async () => {
    try {
      const res = await api({
        url: `/user/sales_persons/getNewsPaperCategories`,
        method: "POST",
        responseType: "json",
      })
      if (res.data && res.data.length) setNewsPaperCategories(res.data)
    } catch (error) {
      if (error.response.status === 401) navigate("/")
    }
  }

  const loadData = async (searchString = "", page = 0) => {
    try {
      seteditTarget(-1)
      seteditTarget_ind(-1)
      setLoader(true)
      let regionLocationRecent = {}
      if (initialRender) {
        regionLocationRecent = {
          user_type: REGIONLOCATION.user_type,
          type: REGIONLOCATION.type,
          value: REGIONLOCATION.value,
        }
      }
      const res = await api({
        url: `/user/sales_persons/getSalespersons`,
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          search: searchString,
          new_user_type_filter,
          assigned_status_filter
          // sales_ops:
          //   initialRender && SALES !== "" && SALES.type === "user"
          //     ? regionLocationRecent
          //     : SALES === ""
          //       ? { index: 0, type: "user_type", value: 0 }
          //       : SALES,
        },
      })
      setData(res?.data?.data?.length ? res?.data?.data : [])
      setTotalPages(Math.ceil(res.data.total / config.PER_PAGE))
      setLoader(false)
    } catch (error) {
      setLoader(false)
      if (error.response.status === 401) navigate("/")
    }
  }

  useEffect(() => {
    if (SALES !== "" && !initialRender) {
      loadData()
    }
  }, [SALES])

  useEffect(() => {
    loadData()
    setInitialRender(false)
  }, [])

  const assignTargetFunction = async (item) => {
    try {
      const res = await api({
        url: `/user/sales_persons/assigntarget`,
        method: "POST",
        responseType: "json",
        data: {
          newTarget: item.value,
          sales_person_id: item.sales_person_id,
        },
      })
      loadData(search, 0)
    } catch (error) {
      console.log(error)
    }
  }

  const getlogs = async (sales_person_id) => {
    try {
      const res = await api({
        url: "/user/sales_persons/gettargetlogs",
        method: "POST",
        responseType: "json",
        data: {
          sales_person_id,
        },
      })
      setLogdata(res.data)
    } catch (error) { }
  }

  const toTitleCase = (str) => {
    try {
      if (str !== " " && str !== undefined) {
        const newStr = str
          ?.split(" ")
          .map((w) => w[0].toUpperCase() + w.substring(1).toLowerCase())
          .join(" ")
        return newStr
      }
      return "-"
    } catch (error) {
      console.log(error)
    }
  }

  const storeRegion = async (e) => {
    setRegionChange(e.target.value)
    await getLocations(e.target.value, type)
  }

  const getRegions = async (type) => {
    try {
      const response = await api({
        url: `/user/sales_persons/getregions`,
        method: "POST",
        responseType: "json",
        data: { type },
      })
      if (response?.data) {
        setRegions(response?.data)
      }
    } catch (error) {
      console.log("error")
    }
  }

  const getLocations = async (region, type) => {
    try {
      const response = await api({
        url: `/user/sales_persons/getlocations`,
        method: "POST",
        responseType: "json",
        data: {
          region,
          type,
        },
      })
      if (response?.data) {
        setLocations(response?.data)
      }
    } catch (error) {
      console.log("error")
    }
  }

  const getDesignations = async () => {
    try {
      const response = await api({
        url: `/user/sales_persons/getdesignations`,
        method: "POST",
        responseType: "json",
      })
      if (response?.code === 200) {
        setDesignations(response?.data)
      }
    } catch (error) {
      console.log("error")
    }
  }

  const handleLoc = () => {
    setRegion("")
    setLocationView(true)
  }

  const handleReg = () => {
    setLocation("")
    setView(true)
  }

  const handleDes = () => {
    setDesignationString("")
    setDesignationView(true)
  }

  const handleRegionChange = (e) => {
    setRegion(e.target.value.trim())
  }

  const handleLocationChange = (e) => {
    setLocation(e.target.value.trim())
  }

  const handleDesignationChange = (e) => {
    setDesignationString(e.target.value.trim())
  }

  const searchData = debounce((e) => {
    setSearch(e.target.value)
    setCurrentPage(0)
    loadData(e.target.value, 0)
    setOtp({})
  }, 500)

  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault()
    }
  }

  const handledelClose = () => {
    setDel(false)
  }

  const formik = useFormik({
    initialValues: JSON.parse(JSON.stringify(initialSalesperson)),
    validationSchema: flag === "edit" ? SalespersonEditSchema : SalespersonSchema,
    onSubmit: async (values, { resetForm }) => {
      values.permissions = selectedPermissions.map(option => option.value)
      values.whatsapp_reports = values.whatsapp_reports || false
      values.alpha_head = values.alpha_head || false
      values.is_vendor_admin = values.is_vendor_admin || false
      values.subordinates = values.subordinates || []
      values.ishead = values.ishead || false

      if (values.newspaper_category_id && showNewspaperCategory) {
        const categoryObj = newspaperCategories.find((cat) => cat.category_id === values.newspaper_category_id)
        values.newspaper_category_name = categoryObj?.category_name || ""
      }
      if(flag !== "edit" && values.team === "alpha"){
        Toast("error", "Salesperson creation is restricted for input apha") 
        return;
      }
      try {
        const url = flag === "edit" ? `/user/sales_persons/${id}` : `/user/sales_persons`
        const method = flag === "edit" ? "PUT" : "POST"
        const payload = {...values, ref_table:"sales_persons"}
        // Password is never editable — don't send it on edit, even a stale/empty value
        if (flag === "edit") delete payload.password
        const res = await api({
          url,
          method,
          responseType: "json",
          data: payload,
        })

        if (res.code !== 200) {
          Toast("error", res.data?.message || res.message)
          return
        }

        Toast("success", flag === "edit" ? "Edited Sales Person Request Sent Successfully" : "Sales Person Added Request Sent Successfully")
        resetForm()
        handleClose()
        setCurrentPage(0)
        setSearch("")
        loadData("", 0)
        setOtp({})
        setSelectedPermissions([])
        setSelectedSalesPersons([])
        setAssignedSalesPersons([])
        setDesignations([])
        setNewsPaperCategories([])
        setId(null)

      } catch (error) {
        const er = error?.response?.message || "Something went wrong"
        Toast("error", er)
        if (error.response.status === 401) navigate("/")
      }
    },
  })

  const defaultValue = (options, value) => {
    return options ? options.find((option) => option.value === value) || "" : ""
  }

  const handleRegion = async () => {
    const advregex = /^(?! )[A-Za-z]*\s*[A-Za-z]*/
    if (!region.match(advregex)) {
      Toast("error", "Region can't start with special characters")
      return
    }
    
    try {
      const res = await api({
        url: `/user/sales_persons/region`,
        method: "POST",
        responseType: "json",
        data: { region, type },
      })
      
      if (res?.data?.code === 500) {
        Toast("error", res.data.message)
        setRegion("")
      } else {
        Toast("success", "Region Added Successfully")
        handle()
        getRegions(type)
        setView(false)
        setRegion("")
      }
    } catch (error) {
      const er = error?.response?.message || "Something went wrong"
      Toast("error", er)
      setRegion("")
      if (error.response.status === 401) navigate("/")
    }
  }

  const handleLocation = async () => {
    const advregex = /^(?! )[A-Za-z]*\s*[A-Za-z]*/
    if (!location.match(advregex)) {
      Toast("error", "Location can't start with special characters")
      return
    }
    
    try {
      const res = await api({
        url: `/user/sales_persons/location`,
        method: "POST",
        responseType: "json",
        data: {
          location,
          region_id: regionChange,
          type,
        },
      })
      
      if (res?.data?.code === 500) {
        Toast("error", res.data.message)
        setLocation("")
      } else {
        Toast("success", "Location Added Successfully")
        handle()
        getLocations(regionChange, type)
        setLocationView(false)
        setLocation("")
      }
    } catch (error) {
      const er = error?.response?.message || "Something went wrong"
      Toast("error", er)
      setLocation("")
      if (error.response.status === 401) navigate("/")
    }
  }

  const handleDesignation = async () => {
    const advregex = /^(?! )[A-Za-z]*\s*[A-Za-z]*/
    if (!designationString.match(advregex)) {
      Toast("error", "Designation can't start with special characters")
      return
    }
    
    try {
      const res = await api({
        url: `/user/sales_persons/designation`,
        method: "POST",
        responseType: "json",
        data: { designationString },
      })
      
      if (res?.data?.code === 500) {
        Toast("error", res.data.message)
        setDesignationString("")
      } else {
        Toast("success", "Designation Added Successfully")
        handle()
        getDesignations()
        setDesignationView(false)
        setDesignationString("")
      }
    } catch (error) {
      const er = error?.response?.message || "Something went wrong"
      Toast("error", er)
      setDesignationString("")
      if (error.response.status === 401) navigate("/")
    }
  }

  useEffect(() => {
    getRegions(type)
  }, [type])

  const viewOTP = async (mobile, userType, index) => {
    try {
      const res = await api({
        url: `/user/sales_persons/viewOTP`,
        method: "POST",
        responseType: "json",
        data: {
          mobileno: mobile,
          type: userType,
        },
      })
      if (res?.code === 200) {
        setOtp(prev => ({
          ...prev,
          [index]: res?.data?.length ? res?.data[0].otp : "OTP not found"
        }))
      } else {
        Toast("error", res.data.message)
        setOtp(prev => ({ ...prev, [index]: "" }))
      }
    } catch (error) {
      const er = error?.response?.message || "Something went wrong"
      Toast("error", er)
      setOtp({})
      if (error.response.status === 401) navigate("/")
    }
  }

  const options = orderTablePermissions.map((permission) => ({
    value: permission.value,
    label: permission.label,
  }))

  const getAssignedSalesPersons = async (type, region) => {
    try {
      const response = await api({
        url: `/user/sales_persons/getAssignedSalesPersons`,
        method: "POST",
        responseType: "json",
        data: { region, type },
      })
      if (response?.data) {
        setAssignedSalesPersons(response?.data)
      }
    } catch (error) {
      console.log("error")
    }
  }

  const getSubordinates = async (new_user_type, user_id) => {
    try {
      const response = await api({
        url: `/user/sales_persons/getSubordinateslist`,
        method: "POST",
        responseType: "json",
        data: { user_id, new_user_type },
      })
      if (response?.data) {
        setSubordinatesList(response?.data)
      }
    } catch (error) {
      console.log("error")
    }
  }

  const getvalues = (Array, field) => {
    if (Array.length > 0) {
      switch (field) {
        case "assigned_sales_persons":
          return Array.filter((option) => formik.values.assigned_sales_persons?.includes(option.value))
        case "subordinates":
          return Array.filter((option) => formik.values.subordinates?.includes(option.value))
        default:
          return []
      }
    }
    return []
  }

  const handleCategoryChange = (selected) => {
    if (selected) {
      formik.setFieldValue("newspaper_category_id", selected.value)
      formik.setFieldValue("newspaper_category_name", selected.label)
    } else {
      formik.setFieldValue("newspaper_category_id", null)
      formik.setFieldValue("newspaper_category_name", null)
    }
  }

  useEffect(() => {
    if(!initialRender)
     loadData(search, 0)
  }, [new_user_type_filter, assigned_status_filter])
  console.log(formik.values.team, flag)
  return (
    <>
      <SlDrawer label="Are you sure!" open={del} onSlRequestClose={handleRequestClose} onSlAfterHide={handledelClose}>
        <p>
          The Sales Person <span style={{ fontFamily: "Arial", fontWeight: "bold" }}>{delname}</span> will be deleted
        </p>
        <div className="d-flex gap-2">
          <Button variant="success" onClick={() => setDel(false)}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              setDel(false)
              deleteSales(delId)
            }}
          >
            Confirm
          </Button>
        </div>
      </SlDrawer>
      <div className="flex gap-4 justify-end mb-4">
        <SlInput
          size="small"
          id="myInput"
          onSlInput={searchData}
          placeholder="Search By Name / Email / Mobile.."
        >
          <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
        </SlInput>
        <Select
          aria-label="User Type"
          name="new_user_type_filter"
          placeholder='select'
          value={defaultValue(tempBrandsTypes, new_user_type_filter)}
          onChange={selected => setNew_user_type_filter(selected.value)}
          options={tempBrandsTypes} />
        <Select
          aria-label="Assigned Status"
          name="assigned_status_filter"
          placeholder='select'
          value={defaultValue(assignedStatusOptions, assigned_status_filter)}
          onChange={selected => setAssigned_status_filter(selected.value)}
          options={assignedStatusOptions} />
        <SlButton
          size="small"
          variant="primary"
          onClick={() => {
            handleShow("add", {})
            setFlag("add")
          }}
        >
          Add Sales
        </SlButton>
      </div>
      <SlDrawer
        label={flag === "edit" ? "Edit Sales Person" : "Create Sales Person"}
        open={show}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={handleClose}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <label className="mb-1"> Name</label>
            <span className="text-red-600">*</span>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Sales Person Name"
              name="name"
              value={formik.values.name}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              disabled={flag === "edit" && formik.values.team === "alpha"}
            />
            {submit && formik.errors.name && <div className="text-red-600">{formik.errors.name}</div>}
          </div>
          <div className="mb-3">
            <label className="mb-1">Email</label>
            <span className="text-red-600">*</span>
            <input
              type="email"
              className="form-control"
              placeholder="Enter Email"
              name="email"
              value={formik.values.email}
              disabled={flag === "edit" && formik.values.team === "alpha"}

              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
            />
            {submit && formik.errors.email && <div className="text-red-600">{formik.errors.email}</div>}
          </div>
          <div className="mb-3">
            <label className="mb-1"> Mobile No</label>
            <span className="text-red-600">*</span>
            <input
              className="form-control"
              type="tel"
              name="mobile"
              placeholder="Enter Mobile No"
              disabled={flag === "edit" && formik.values.team === "alpha"}

              value={formik.values.mobile}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
            />
            {submit && formik.errors.mobile && <div className="text-red-600">{formik.errors.mobile}</div>}
          </div>
          {flag !== "edit" && (
            <div className="mb-3">
              <label className="mb-1"> Password</label>
              <span className="text-red-600">*</span>
              <input
                className="form-control"
                type="text"
                name="password"
                placeholder="Enter Password"
                value={formik.values.password}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
              {submit && formik.errors.password && <div className="text-red-600">{formik.errors.password}</div>}
            </div>
          )}
          <div className="mb-3">
            <label className="mb-1"> Select Type </label>
            <span className="text-red-600">*</span>
            <select
              className="form-select"
              name="type"
              value={formik.values.type}
              onBlur={formik.handleBlur}
              disabled={flag === "edit" && formik.values.team === "alpha"}
              onChange={async (e) => {
                formik.handleChange(e)
                handleTypeChange(e)
                await getAssignedSalesPersons(e.target.value, "")
                formik.setFieldValue("location", "")
                setRegionChange("")
                formik.setFieldValue("assigned_sales_persons", [])
                setSelectedSalesPersons([])
              }}
            >
              <option value="0">Select Type</option>
              <option value="-1">Main</option>
              <option value="1">National</option>
              <option value="2">Local</option>
            </select>
            {submit && formik.errors.type && <div className="text-red-600">{formik.errors.type}</div>}
          </div>
          {type !== "0" && (
            <div className="mb-3">
              <div className="flex gap-4 items-center mb-3">
                <label>{type === "1" ? "Region" : type === "2" ? "State" : "Region"}</label>
                <SlButton size="small" variant="primary" outline onClick={handleReg}>
                  Add New {type === "1" ? "Region" : type === "2" ? "State" : "Region"}
                </SlButton>
              </div>
              <select
                className="form-select"
                name="region"
                value={formik.values.region}
                // disabled={flag === "edit" && formik.values.team === "alpha"}
                onBlur={formik.handleBlur}
                onChange={async (e) => {
                  formik.handleChange(e)
                  storeRegion(e)
                  formik.setFieldValue("assigned_sales_persons", [])
                  setSelectedSalesPersons([])
                  if (type === "1" && e.target.value !== "") {
                    await getAssignedSalesPersons(type, e.target.value)
                  }
                }}
              >
                <option value="">Select Type</option>
                {regions?.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
              {submit && formik.errors.region && <div className="text-red-600">{formik.errors.region}</div>}
            </div>
          )}
          {regionChange !== "" && (
            <div className="mb-3">
              <div className="flex gap-4 items-center mb-3">
                <label>{type === "1" ? "Location" : type === "2" ? "District" : "Location"}</label>
                <SlButton size="small" variant="primary" outline onClick={handleLoc}>
                  Add New {type === "1" ? "Location" : type === "2" ? "District" : "Location"}
                </SlButton>
              </div>
              <select
                className="form-select"
                name="location"
                value={formik.values.location}
                onBlur={formik.handleBlur}
                // disabled={flag === "edit" && formik.values.team === "alpha"}
                onChange={formik.handleChange}
              >
                <option value="">Select Type</option>
                {locations?.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
              {submit && formik.errors.location && <div className="text-red-600">{formik.errors.location}</div>}
            </div>
          )}

          {(formik.values.type === "1" && !regionChange && !formik.values.location) ||
            (formik.values.type === "1" && regionChange && !formik.values.location) ||
            (formik.values.type === "2" && !regionChange && !formik.values.location) ||
            (flag === "edit" && formik.values.type === 1 && !regionChange && formik.values.location === -1) ||
            (flag === "edit" && formik.values.type === 1 && regionChange && formik.values.location === -1) ||
            (flag === "edit" && formik.values.type === 2 && !regionChange) ? (
            <div className="mb-3">
              <label>Assigned SalesPersons </label>
              <Select
                isMulti
                options={assignedSalesPersons}
                name="assigned_sales_persons"
                className="basic-multi-select"
                classNamePrefix="select"
                value={getvalues(assignedSalesPersons, "assigned_sales_persons")}
                onChange={(selectedOptions) => {
                  formik.setFieldValue(
                    "assigned_sales_persons",
                    selectedOptions.map((item) => item.value),
                  )
                }}
              />
            </div>
          ) : null}

          <div className="mb-3">
            <label className="form-label">Team</label>
            <span className="text-red-600">*</span>
            <Select
              name="team"
              placeholder="Select Team"
              value={defaultValue(teams, formik.values.team)}
              onBlur={formik.handleBlur}
              disabled={flag === "edit" && formik.values.team === "alpha"}
              onChange={(selected) => {
                formik.setFieldValue("team", selected.value)
                if (selected.value.toLowerCase() === "metro") {
                  getNewsPaperCategories()
                  setShowNewspaperCategory(true)
                } else {
                  setShowNewspaperCategory(false)
                  formik.setFieldValue("newspaper_category_id", null)
                  formik.setFieldValue("newspaper_category_name", null)
                }
              }}
              options={teams}
            />
            {submit && formik.errors.team && <div className="text-red-600">{formik.errors.team}</div>}
          </div>

          {showNewspaperCategory && (
          <div className="mb-3">
            <label className="form-label">Newspaper Category</label>
            <span className="text-red-600">*</span>
            <Select
              name="newspaper_category_id"
              placeholder="Select Newspaper Category" 
              value={newspaperCategories
                .filter(category => category.category_id === formik.values.newspaper_category_id)
                .map(category => ({
                  label: category.category_name,
                  value: category.category_id
                }))}
              onChange={(selectedOption) => {
                formik.setFieldValue("newspaper_category_id", selectedOption ? selectedOption.value : "");
                handleCategoryChange(selectedOption); 
              }}
              onBlur={formik.handleBlur}
              options={newspaperCategories.map((category) => ({
                value: category.category_id,
                label: category.category_name,
              }))}
            />
    {submit && formik.errors.newspaper_category_id && (
      <div className="text-red-600">{formik.errors.newspaper_category_id}</div>
    )}
  </div>
)}


          <div className="mb-3">
            <label>Permissions </label>
            <Select
              isMulti
              options={options}
              name="permissions"
              className="basic-multi-select"
              classNamePrefix="select"
              value={selectedPermissions}
              onChange={setSelectedPermissions}
            />
          </div>

          <div className="mb-3">
            <div className="form-check">
              <input
                className="form-check-input"
                name="whatsapp_reports"
                type="checkbox"
                id="whtasapp_id"
                checked={formik.values.whatsapp_reports}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
              <label className="form-check-label" htmlFor="whtasapp_id">
                Whatsapp Reports
              </label>
            </div>
          </div>

          <div className="mb-3">
            <div className="form-check">
              <input
                className="form-check-input"
                name="alpha_head"
                type="checkbox"
                id="alpha_head_id"
                checked={formik.values.alpha_head}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
              <label className="form-check-label" htmlFor="alpha_head_id">
                Alpha Head
              </label>
            </div>
          </div>

          <div className="mb-3">
            <div className="form-check">
              <input
                className="form-check-input"
                name="is_vendor_admin"
                type="checkbox"
                id="is_vendor_admin_id"
                checked={!!formik.values.is_vendor_admin}
                onBlur={formik.handleBlur}
                onChange={(e) => formik.setFieldValue("is_vendor_admin", e.target.checked)}
              />
              <label className="form-check-label" htmlFor="is_vendor_admin_id">
                Vendor Admin
              </label>
            </div>
          </div>

          <div className="mb-3">
            <label className="mb-1"> Select New Type </label>
            <span className="text-red-600">*</span>
            <select
              className="form-select"
              name="new_user_type"
              value={formik.values.new_user_type}
              onBlur={formik.handleBlur}
              onChange={async (e) => {
                formik.handleChange(e)
                await getSubordinates(e.target.value, id)
              }}
            >
              <option value="0">Select New Type</option>
              <option value="-1">Main</option>
              {BrandsTypes.map((item) => (
                <option value={item.value} key={item.value}>
                  {item.label}
                </option>
              ))}
              <option value="6">Network</option>
            </select>
            {submit && formik.errors.new_user_type && (
              <div className="text-red-600">{formik.errors.new_user_type}</div>
            )}
          </div>

          <div className="mb-3">
            <div className="flex gap-4 items-center mb-3">
              <label>Designation <span className="text-red-600">*</span></label>
              <SlButton size="small" variant="primary" outline onClick={handleDes}>
                Add New Designation
              </SlButton>
            </div>
            <select
              className="form-select"
              name="designation"
              value={formik.values.designation}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
            >
              <option value="0">Select</option>
              {designations?.map((item) => (
                <option value={item.id} key={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
            {submit && formik.errors.designation && (
              <div className="text-red-600">{formik.errors.designation}</div>
            )}
          </div>

          <div className="mb-3">
            <label>SubOrdinates</label>
            <Select
              isMulti
              options={subordinatesList}
              name="subordinates"
              className="basic-multi-select"
              classNamePrefix="select"
              value={getvalues(subordinatesList, "subordinates")}
              onChange={(selectedOptions) => {
                formik.setFieldValue(
                  "subordinates",
                  selectedOptions.map((item) => item.value),
                )
              }}
            />
          </div>

          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              name="ishead"
              id="ishead"
              checked={formik.values.ishead}
              onBlur={formik.handleBlur}
              onChange={() => formik.setFieldValue("ishead", !formik.values.ishead)}
            />
            <label className="form-check-label" htmlFor="ishead">
              Head
            </label>
            {submit && formik.errors.ishead && <div className="text-red-600">{formik.errors.ishead}</div>}
          </div>

          {flag === "edit" && (
            <div className="mb-3 form-check form-switch">
              <label className="form-check-label">
                Status ({formik.values.status ? "Active" : "Inactive"})
              </label>
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                checked={formik.values.status}
                onChange={() => {
                  formik.setFieldValue("status", formik.values.status ? 0 : 1)
                }}
              />
            </div>
          )}

          <div slot="footer">
            <SlButton
              type="submit"
              variant="primary"
              size="small"
              onClick={() => setSubmit(true)}
            >
              Submit
            </SlButton>
          </div>
        </form>
      </SlDrawer>

      <SlDrawer label={`Add ${type === "1" ? "Region" : type === "2" ? "State" : "Region"}`} open={view} onSlAfterHide={handle}>
        <div className="mb-3">
          <label className="mb-1">
            {type === "1" ? "Region" : type === "2" ? "State" : "Region"} <span className="text-red-600">*</span>
          </label>
          <form className="inline-validation">
            <input className="form-control" placeholder="Enter Region" name="adv_name" onChange={handleRegionChange} />
            <br />
            <SlButton type="reset" variant="primary" onClick={handleRegion}>
              Submit
            </SlButton>
          </form>
        </div>
      </SlDrawer>

      <SlDrawer label={`Add ${type === "1" ? "Location" : type === "2" ? "District" : "Location"}`} open={locationview} onSlAfterHide={handle}>
        <div className="mb-3">
          <label className="mb-1">
            {type === "1" ? "Location" : type === "2" ? "District" : "Location"} <span className="text-red-600">*</span>
          </label>
          <form className="inline-validation">
            <input className="form-control" placeholder="Enter Location" name="adv_name" onChange={handleLocationChange} />
            <br />
            <SlButton type="reset" variant="primary" onClick={handleLocation}>
              Submit
            </SlButton>
          </form>
        </div>
      </SlDrawer>

      <SlDrawer label="Add Designation" open={designationView} onSlAfterHide={() => setDesignationView(false)}>
        <div className="mb-3">
          <label className="mb-1">
            Designation <span className="text-red-600">*</span>
          </label>
          <form className="inline-validation">
            <input className="form-control" placeholder="Enter Designation" name="adv_name" onChange={handleDesignationChange} />
            <br />
            <SlButton type="reset" variant="primary" onClick={handleDesignation}>
              Submit
            </SlButton>
          </form>
        </div>
      </SlDrawer>

      <SlDrawer open={open} onSlAfterHide={handle}>
        <div className="overflow-x-auto mb-4">
          <h3 className="text-center">{salesp} </h3>
          <br />
          <ScrollContainer>
            <table className="table-base">
              <thead>
                <tr>
                  <th scope="col">S.No</th>
                  <th scope="col">Department</th>
                </tr>
              </thead>
              {depts?.length > 0 ? (
                <tbody>
                  {depts.map((item, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{item}</td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <NoDataFound colspan={2} />
              )}
            </table>
          </ScrollContainer>
        </div>
      </SlDrawer>

      <div className="mb-4">
        <ScrollContainer>
          <table className="table table-bordered">
            <thead className="sticky top-0">
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Password</th>
                <th>Type</th>
                <th>Region</th>
                <th>Location</th>
                <th>User Type</th>
                <th>Assigned to</th>
                <th>Designation</th>
                <th>Created Date</th>
                <th>Status</th>
                <th>Created By</th>
                <th>Department</th>
                <th>Team</th>
                <th>View OTP</th>
                {localStorage.getItem("role") === roles.salesperson && salesUserType && <th> Target Amount</th>}
                <th>Actions</th>
              </tr>
            </thead>
            {data?.length && !loader ? (
              <tbody>
                {data.map((item, index) => (
                  <tr key={item.sales_person_id} className="group/details hover:bg-slate-100">
                    <th scope="row" className="flex items-center justify-center text-center gap-2">
                        {item?.mc_actions?.length ?<button className="h-2 w-2 px-1 py-1 rounded-full bg-orange-300" title={`pending edit action by ${item?.mc_actions?.[0]?.mc_user_name}`} onClick={() => setSelectedMcId(item?.mc_actions?.[0]?.mc_id)}></button>: null}
                        <span>{item.name}</span>
                    </th>
                    <td>{item.email}</td>
                    <td>{item.mobile}</td>
                    <td>{item.password}</td>
                    <td>{item.type === 1 ? "National" : item.type === 2 ? "Local" : item.type === -1 ? "Main" : "-"}</td>
                    <td>{toTitleCase(item.regionName)}</td>
                    <td>{toTitleCase(item.locationName)}</td>
                    <td>{tempBrandsTypes.find(britem => britem.value === item.new_user_type)?.label || ""}</td>
                    <td>{item.assigned_me_to || '-'}</td>
                    <td>{toTitleCase(item.designationname) || "-"}</td>
                    <td>{formatDateWithTime(item.created_date)}</td>
                    <td>
                      <span className={item.status ? "full-badge text-center" : "unpaid-badge text-center"}>
                        {item.status ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td>{item.user_name || "-"}</td>
                    <td>
                      <SlTooltip content="View Departments">
                        <SlIconButton
                          library="lucide"
                          name="view"
                          onClick={() => {
                            handleDept()
                            viewDept(item.department_id)
                            setSalesp(item.name)
                          }}
                        ></SlIconButton>
                      </SlTooltip>
                    </td>
                    <td>{item.team}</td>
                    <td>
                      {otp[index] ? (
                        <span>{otp[index]}</span>
                      ) : (
                        <SlTooltip content="View OTP">
                          <SlIconButton
                            library="lucide"
                            name="eye"
                            onClick={() => viewOTP(item.mobile, "sales_person", index)}
                          ></SlIconButton>
                        </SlTooltip>
                      )}
                    </td>
                    {localStorage.getItem("role") === roles.salesperson && salesUserType && (
                      <td>
                        {index === editTarget_ind ? (
                          <>
                            <div className="mb-1">
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={editTarget}
                                onChange={(e) => seteditTarget(e.target.value)}
                              />
                            </div>
                            <div className="flex gap-2">
                              <SlButton
                                size="small"
                                onClick={() => {
                                  if (+editTarget < 0) {
                                    Toast("error", "Target must be greater than 0")
                                    return
                                  }
                                  assignTargetFunction({ value: editTarget, sales_person_id: item.sales_person_id })
                                  seteditTarget_ind(-2)
                                  seteditTarget(-2)
                                }}
                              >
                                Save
                              </SlButton>
                              <SlButton
                                size="small"
                                onClick={() => {
                                  seteditTarget_ind(-2)
                                  seteditTarget(-2)
                                }}
                              >
                                Cancel
                              </SlButton>
                            </div>
                          </>
                        ) : (
                          <div className="flex items-center gap-2 group/position">
                            {item.target.present}
                            {localStorage.getItem("role") === roles.salesperson && salesUserType && (
                              <span className="hidevisible group-hover/position:visible">
                                <SlTooltip content="Assign Target">
                                  <SlIconButton
                                    library="lucide"
                                    name="edit"
                                    style={{ backgroundColor: "transparent" }}
                                    onClick={() => {
                                      seteditTarget_ind(index)
                                      seteditTarget(item.target.present)
                                    }}
                                  ></SlIconButton>
                                </SlTooltip>
                              </span>
                            )}
                          </div>
                        )}
                      </td>
                    )}
                    <td>
                      <div className="inline-flex gap-3">
                        <form action="" method="POST">
                          {!salesUserType && (
                            <SlTooltip content="Edit Sales">
                              <SlIconButton
                                library="lucide"
                                name="edit"
                                onClick={() => {
                                  setFlag("edit")
                                  handleShow("edit", item)
                                  setId(item.sales_person_id)
                                }}
                              ></SlIconButton>
                            </SlTooltip>
                          )}
                          {salesUserType && (
                            <SlTooltip content="View Target Logs">
                              <SlIconButton
                                library="lucide"
                                name="view"
                                onClick={() => {
                                  setlogshow({ salesName: item.name, show: true })
                                  getlogs(item.sales_person_id)
                                }}
                              ></SlIconButton>
                            </SlTooltip>
                          )}
                        </form>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : !data?.length && !loader ? (
              <NoDataFound colspan="9" />
            ) : (
              <TableLoader colspan="9" />
            )}
          </table>
        </ScrollContainer>
      </div>

      {totalPages > 1 && (
        <div className="flex justify-end">
          <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />
        </div>
      )}

      <SlDrawer
        label={`Target Log details of ${logshow?.salesName}`}
        open={logshow?.show}
        onSlAfterHide={() => {
          setlogshow({})
          setLogdata([])
        }}
      >
        <div className="overflow-x-auto">
          <table className="table table-bordered">
            <thead>
              <tr>
                <td>Name</td>
                <td>Target</td>
                <td>Time</td>
              </tr>
            </thead>
            {logdata?.length ? (
              <tbody>
                {logdata?.map((item) => (
                  <tr key={item.id}>
                    <td>{toTitleCase(item.action_name)}</td>
                    <td>{item.target}</td>
                    <td>{formatDateWithTime(item.time)}</td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <NoDataFound />
            )}
          </table>
        </div>
      </SlDrawer>
      <PendingRequestModal mc_id={selectedMcId} isOpen={!!selectedMcId} onClose={handleCloseModal} />
    </>
  )
}

export default Sales